import React from 'react';
import NextScript, { ScriptProps } from 'next/script';

const enableCondition = process.env.NEXT_PUBLIC_ANALYTICS_ENABLE !== 'false';

export default function Script(props: ScriptProps) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return enableCondition ? <NextScript {...props} /> : null;
}
